import React, { useState, useContext } from 'react';
import Sticky from 'react-stickynode';
import { Link, withRouter } from 'react-router-dom';
import { IoIosClose } from 'react-icons/io';
import Button from '@isomorphic/shared/UIView/Antd/Button/Button';
import Drawer from '@isomorphic/shared/UIView/Antd/Drawer/Drawer';
import Logo from '@isomorphic/shared/UIView/Logo/Logo';
import Text from '@isomorphic/shared/UIView/Text/Text';
import TextLink from '@isomorphic/shared/UIView/TextLink/TextLink';
import Navbar from '@isomorphic/shared/hotel/components/Navbar/Navbar';
import { AuthContext } from '../../../context/AuthProvider';
import { LayoutContext } from '../../../context/LayoutProvider';
import useWindowSize from '@isomorphic/shared/Library/hooks/useWindowSize';
import { AGENT_PROFILE_PAGE } from '../../../settings/constant';
import AuthMenu from './AuthMenu';
import MainMenu from './MainMenu';
import MobileMenu from './MobileMenu';
import ProfileMenu from './ProfileMenu';
import NavbarSearch from './NavbarSearch';
import { Icon,Avatar } from 'antd';
import HeaderWrapper, {
  MobileNavbar,
  CloseDrawer,
  AvatarWrapper,
  AvatarImage,
  AvatarInfo,
  LogoArea,
} from './Header.style';

// Dummy images
import DemoLogo from '@isomorphic/shared/hotel/assets/images/logo.png';
import AvatarImg from '@isomorphic/shared/hotel/assets/images/accountbold.png';

export default withRouter(function Header({ location }) {
  const [{ searchVisibility }] = useContext(LayoutContext);
  // auth context
  const { loggedIn } = useContext(AuthContext);

  // sidebar and responsive control state
  const [state, setState] = useState(false);

  // sidebar handler function
  const sidebarHandler = () => {
    setState(!state);
  };

  // useWindowSize hook
  const { width } = useWindowSize();

  // check header type  searchComponent={<NavbarSearch />}
  const headerType = location.pathname === '/' ? 'default' : 'default';

  return (
    <HeaderWrapper>
      <Sticky top={0} innerZ={10001} activeClass="isHeaderSticky">
        {width > 991 ? (
          <Navbar
            logo={
              <Link to="/">
                <Logo src={DemoLogo} title="ZIAWAY" />
              </Link>
            }
            navMenu={<MainMenu isLogin={loggedIn}/>}
            authMenu={<AuthMenu />}
            isLogin={loggedIn}
            avatar={<Logo src={AvatarImg} title="ZIAWAY" />}
            profileMenu={
              <ProfileMenu avatar={<Logo src={AvatarImg} title="ZIAWAY" />} />
            }
            headerType={headerType}
           
            location={location}
            searchVisibility={searchVisibility}
          />
        ) : (
          <MobileNavbar className={headerType}>
            <LogoArea>
              <Link to="/">
                <Logo src={DemoLogo} title="Ziaway" />
              </Link>
              {/*<NavbarSearch />*/}
            </LogoArea>
            <Button
              className={`hamburg-btn ${state ? 'active' : ''}`}
              onClick={sidebarHandler}
            >
              <span />
              <span />
              <span />
            </Button>
            <Drawer
              placement="right"
              closable={false}
              onClose={sidebarHandler}
              width="285px"
              className="mobile-header"
              visible={state}
            >
              <CloseDrawer>
                <button onClick={sidebarHandler}>
                  <IoIosClose />
                </button>
              </CloseDrawer>
              {loggedIn ? (
                <AvatarWrapper>
                  <AvatarImage>
                    <Logo src={AvatarImg} title="ZiaWay" />
                  </AvatarImage>
                  <AvatarInfo>
                   {/* <Text as="h3" content="Nova Scotia" />*/}
                    <TextLink
                      link={AGENT_PROFILE_PAGE}
                      content="Mes biens"
                    /> 
                  </AvatarInfo>
                </AvatarWrapper>
              ) : (
                <AuthMenu className="auth-menu" />
              )}
              <MobileMenu className="main-menu" />
            </Drawer>
          </MobileNavbar>
        )}
      </Sticky>
    </HeaderWrapper>
  );
});
